<template>
  <div class="add-LayoutFac on_hover">
    <div class="plan__size vw_100">
      <div id="layout-canvas" class="house-titles">
        <img id="imageUrl" :src="imageUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import $ from "jquery"
import Raphael from '@/utils/raphael'

export default {
  name: "ProjectsPlanning",
  props: ['project_planning_id'],

  data() {
    return {
      areasFacade: "",
      imageUrl: ""
    }
  },

  watch: {
    project_planning_id: {
      handler: async function (newVal, oldVal) {
        if (this.project_planning_id) {
          this.loaderBegin()
          await this.fetchProjectPlanningAreas()
          this.jquery()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      getProjectPlanningAreas: "projectPlannings/getProjectPlanningAreas"
    }),

    async fetchProjectPlanningAreas() {
      await this.getProjectPlanningAreas(this.project_planning_id)
        .then((res) => {
          this.areasFacade = res.projectPlanningAreas
          this.imageUrl = res.image_path
        })
        .catch((err) => {

        })
    },

    goFacades(id) {
      let facade = this.areasFacade.find(item => item.id == id)
      if (facade) {
        this.$router.push({
          name: "facadePlanShow",
          params: { house_id: facade.house_id },
        })
      }
    },

    loaderBegin() {
      $(function () {
        $("#loader").append(
          "<div class='loading_div'><div class='load'><img src='/img/GoLoading.gif' alt='' style='height: 70px; width: 70px;'></div><div class='text'>Loading</div></div>"
        )
      })
    },

    jquery() {
      var img = this.imageUrl
      var areas = this.areasFacade
      var self = this
      $(function () {
        var MarkLabel = function (text) {
          this.COLOR = "#FFF"
          this.SIZE = 24
          this.WEIGHT = "bold"
          this.CURSOR = "default"

          this.text = text
          this.x = 0
          this.y = 0
          this.el = this.draw()
          this.el.markType = markPainter.TYPE_LABEL
        }

        /**
         * Отрисовка текста подписи
         *
         * @returns Raphael Object
         */
        MarkLabel.prototype.draw = function () {
          return markPainter.paper
            .text(this.x, this.y, this.text)
            .hide()
            .attr({
              fill: this.COLOR,
              "font-size": this.SIZE,
              "font-weight": this.WEIGHT,
              cursor: this.CURSOR,
            })
            .toFront()
        }

        /**
         * Изменение позиции подписи
         *
         * @param coordinates - координаты относительно канвы
         */
        MarkLabel.prototype.setPosition = function (coordinates) {
          this.x = coordinates.x
          this.y = coordinates.y

          this.el
            .attr({
              x: coordinates.x,
              y: coordinates.y,
            })
            .show()
        }

        /**
         * Удаление подписи
         */
        MarkLabel.prototype.remove = function () {
          this.el.remove()
        }

        /**
         * End Label
         */

        /* Area Class */

        /**
         * Класс области
         *
         * @param points - набор узлов
         * @param id - ID области, если он известен
         * @constructor
         */
        var MarkArea = function (points, id) {
          this.COLOR_RELATED = "#9F51"
          this.COLOR_UNRELATED = "#000"
          this.ACTIVE_RELATED = "#BF71"
          this.ACTIVE_UNRELATED = "#444"

          this.COLOR = this.COLOR_UNRELATED
          this.ACTIVE = this.ACTIVE_UNRELATED
          this.OPACITY = 0.5
          this.STROKE = 2

          this.checkPointsOrder = {
            h: [2, 1, 3],
            v: [2, 1, 3],
          }

          this.points = points
          this.related = false

          this.el = this.draw()

          this.setId(id)

          this.el.markType = markPainter.TYPE_AREA
          this.el.related = false
        }

        /**
         * Отрисовка области
         *
         * @returns Raphael Object
         */
        MarkArea.prototype.draw = function () {
          var $this = this

          return markPainter.paper
            .path(this.getPath())
            .attr({
              fill: this.COLOR,
              "fill-opacity": this.OPACITY,
              "stroke-width": this.STROKE,
            })
            .hover(
              function () {
                if (markPainter.mode !== markPainter.MODE_PAINT) {
                  this.attr("fill", $this.ACTIVE)
                }
              },
              function () {
                this.attr("fill", $this.COLOR)
              }
            )
            .toBack()
        }

        /**
         * Формирование описания пути из координат узлов области
         *
         * @returns {string}
         */
        MarkArea.prototype.getPath = function (points) {
          if (typeof points !== "object") {
            points = this.points
          }

          var path = ""

          for (var i in points) {
            path += path === "" ? "M" : "L"
            path += points[i].x + " " + points[i].y
          }

          return path + "z"
        }

        /**
         * Устанавливает ID области
         *
         * @param id
         */
        MarkArea.prototype.setId = function (id) {
          this.id = id
          this.el.markId = id
        }

        /**
         * Пометить область как отвязанную
         */
        MarkArea.prototype.setUnrelated = function () {
          this.related = false
          this.el.related = false

          this.removeLabel()

          this.COLOR = this.COLOR_UNRELATED
          this.ACTIVE = this.ACTIVE_UNRELATED
          this.el.attr("fill", this.COLOR)
        }

        /**
         * Пометить область как связанную
         *
         * @param text - метка связанного объекта
         */
        MarkArea.prototype.setRelated = function (text) {
          this.related = true
          this.el.related = true

          this.setLabel(text)
          // $('.house-titles svg').append(`<div href="#" class="v-badge">Скоро<span></span></div>`)

          this.COLOR = this.COLOR_RELATED
          this.ACTIVE = this.ACTIVE_RELATED
          this.el.attr("fill", this.COLOR)
        }

        /**
         * Задать подпись для области
         *
         * @param text - текст подписи
         */
        MarkArea.prototype.setLabel = function (text) {
          this.label = new MarkLabel(text)

          this.positionLabel()
        }

        /**
         * Удаляет подпись области
         */
        MarkArea.prototype.removeLabel = function () {
          if (this.label) {
            this.label.remove()

            this.label = null
          }
        }

        /**
         * Позиционирование подписи
         */
        MarkArea.prototype.positionLabel = function () {
          var checkPoints = this.getCheckPoints()
          var goodPoint = checkPoints[0]
          var areaPath = this.el.attrs.path

          var labelBBox = this.label.el.getBBox()
          var labelHalfWidth = labelBBox.width / 2
          var labelHalfHeight = labelBBox.height / 2

          for (var i in checkPoints) {
            var virtualPoints = [
              {
                x: checkPoints[i].x - labelHalfWidth,
                y: checkPoints[i].y - labelHalfHeight,
              },
              {
                x: checkPoints[i].x + labelHalfWidth,
                y: checkPoints[i].y - labelHalfHeight,
              },
              {
                x: checkPoints[i].x + labelHalfWidth,
                y: checkPoints[i].y + labelHalfHeight,
              },
              {
                x: checkPoints[i].x - labelHalfWidth,
                y: checkPoints[i].y + labelHalfHeight,
              },
            ]

            if (
              !Raphael.pathIntersection(areaPath, this.getPath(virtualPoints))
                .length
            ) {
              goodPoint = checkPoints[i]

              break
            }
          }

          this.label.setPosition(goodPoint)
        }

        /**
         * Получение набора точек, подходящих для размещения подписи
         *
         * @returns {Array}
         */
        MarkArea.prototype.getCheckPoints = function () {
          var defPoint
          var points = []
          var bBox = this.el.getBBox()
          var hPart = Math.round(bBox.width / 3)
          var vPart = Math.round(bBox.height / 3)

          for (var i in this.checkPointsOrder.h) {
            var x = Math.round(
              (bBox.x * 2 +
                hPart * (this.checkPointsOrder.h[i] - 1) +
                hPart * this.checkPointsOrder.h[i]) /
              2
            )

            for (var j in this.checkPointsOrder.v) {
              var y = Math.round(
                (bBox.y * 2 +
                  vPart * (this.checkPointsOrder.v[j] - 1) +
                  vPart * this.checkPointsOrder.v[j]) /
                2
              )

              if (typeof defPoint === "undefined") {
                defPoint = { x: x, y: y }
              }

              if (Raphael.isPointInsidePath(this.el.attrs.path, x, y)) {
                points.push({ x: x, y: y })
              }
            }
          }

          return points || [defPoint]
        }

        /**
         * Удаление области и ее узлов
         */
        MarkArea.prototype.remove = function () {
          for (var i in this.points) {
            this.points[i].el.remove()
          }

          this.el.remove()

          if (this.label) {
            this.label.remove()
          }
        }

        /**
         * End are js
         */

        var markPainter

        /* Painter Class */

        /**
         * Класс редактора разметки
         *
         * @param canvas - jQuery-объект для канвы
         * @param options - опции
         * @constructor
         */
        var MarkPainter = function (canvas, options) {
          markPainter = this
          this.isShift = false

          markPainter.MODE_IDLE = "Idle"
          markPainter.MODE_PAINT = "Paint"
          markPainter.MODE_MENU = "Menu"

          markPainter.TYPE_TOOL = "Tool"
          markPainter.TYPE_LINE = "Line"
          markPainter.TYPE_POINT = "Point"
          markPainter.TYPE_AREA = "Area"
          markPainter.TYPE_LABEL = "Label"

          markPainter.nonTargetTypes = [
            markPainter.TYPE_TOOL,
            markPainter.TYPE_LINE,
            markPainter.TYPE_LABEL,
          ]

          markPainter.BUTTON_LEFT = 1
          markPainter.BUTTON_RIGHT = 3

          markPainter.canvas = canvas
          markPainter.paper = new Raphael(
            canvas.attr("id"),
            canvas.width(),
            canvas.height()
          )

          markPainter.toolLine = markPainter.drawToolLine()

          markPainter.options = $.extend(
            {
              functionContextMenu: null,
              functionContextMenuHide: null,
            },
            options
          )

          markPainter.mode = markPainter.MODE_IDLE
          markPainter.currentPath = []
          markPainter.tempLines = []
          markPainter.areas = []
          markPainter.activeArea = null

          markPainter.initAreas()
          markPainter.bindEvents()

          document.addEventListener("keydown", function (event) {
            if (event.shiftKey) {
              markPainter.isShift = true
            }
          })

          document.addEventListener("keyup", function (event) {
            if (event.keyCode == 16) {
              markPainter.isShift = false
            }
          })
        }

        /**
         * Получение координат мыши относительно канвы
         *
         * @param e - событие клика
         * @returns {{x: number, y: number}}
         */
        MarkPainter.prototype.getCoordinates = function (e) {
          return {
            x: e.pageX - 1 - this.canvas.offset().left,
            y: e.pageY - 1 - this.canvas.offset().top,
          }
        }

        /**
         * Загрузка сохраненных областей
         */

        MarkPainter.prototype.initAreas = function () {
          var $this = this
          $this.drawAreas(self.areasFacade)
        }

        /**
         * Отрисовка сохраненных областей
         */
        MarkPainter.prototype.drawAreas = function (areas) {
          for (var a in areas) {
            for (var p in areas[a].points) {
              this.addPoint({
                x: areas[a].points[p].x,
                y: areas[a].points[p].y,
              })
            }

            this.closePath(areas[a].id, areas[a].house)
          }
        }

        /**
         * Назначение событий канвы
         */
        MarkPainter.prototype.bindEvents = function () {
          var $this = this
          this.canvas
            .contextmenu(function (e) {
              e.preventDefault()
            })
            .mouseup(function (e) {
              var method = "click" + e.which
              var target = false
              var coordinates = $this.getCoordinates(e)
              var clickedElements = $this.paper.getElementsByPoint(
                coordinates.x,
                coordinates.y
              )

              const found = e.target.getAttribute('id')
              if (found) self.goFacades(found)

              if (clickedElements.length) {
                clickedElements.forEach(function (el) {
                  // self.goFacades(el.markId)
                  if ($this.nonTargetTypes.indexOf(el.markType) < 0) {
                    target = el
                  }
                })
              }


              if (typeof $this[method] === "function") {
                $this[method].call($this, coordinates, target)
              }
            })
            .mousemove(function (e) {
              if ($this.mode === $this.MODE_PAINT) {
                $this.reDrawToolLine(e)
              }
            })
        }

        /**
         * Создание вспомогательной линии
         *
         * @returns {MarkLine}
         */
        MarkPainter.prototype.drawToolLine = function () {
          var toolLine = new MarkLine()

          toolLine.el.markType = this.TYPE_TOOL

          return toolLine
        }

        /**
         * Перерисовка вспомогательной линии при движении мышью
         *
         * @param coordinates - координаты мыши относительно канвы или событие клика
         */
        MarkPainter.prototype.reDrawToolLine = function (coordinates) {
          if (
            typeof coordinates.x === "undefined" &&
            typeof coordinates.y === "undefined"
          ) {
            coordinates = this.getCoordinates(coordinates)
          }

          coordinates = this.shiftCoordinatesTransform(coordinates)

          this.toolLine.reDraw(
            this.currentPath[this.currentPath.length - 1],
            coordinates
          )
        }

        /**
         * Вызов функции "Скрытие контекстного меню"
         */
        MarkPainter.prototype.executeContextMenuHide = function () {
          if (typeof this.options.functionContextMenuHide === "function") {
            this.options.functionContextMenuHide()

            this.activeArea = null

            this.mode = this.MODE_IDLE
          }
        }

        /**
         * Добавление узла
         *
         * @param coordinates - координаты курсора относительно канвы
         */
        MarkPainter.prototype.addPoint = function (coordinates) {
          var isFirst = this.currentPath.length ? false : true

          if (this.currentPath.length > 1) {
            this.currentPath[this.currentPath.length - 1].setDefault()
          }

          this.currentPath.push(new MarkPoint(coordinates, isFirst))
        }

        /**
         * Завершение рисования пути
         *
         * @param areaId - ID области, если она отрисовывается при инициализации
         * @param preset - пресет, если область связана
         */
        MarkPainter.prototype.closePath = function (areaId, house) {
          var area = new MarkArea(this.currentPath, areaId)

          if (area) {
            try {
              if (house) {
                area.setRelated("Дом: " + house + ' \n(Скоро)')
              }
            } catch (e) {
              console.error(
                "Не правильно размечена планировка areaId " + areaId
              )
              console.error(e.message)
              show1Error(
                "Не правильно размечена планировка обратитесь в техническую поддержку Profitbase"
              )
            }
          }

          this.addArea(area)

          this.cancelDrawing()
        }

        /**
         * Добавление области к разметке
         *
         * @param area - область
         */
        MarkPainter.prototype.addArea = function (area) {
          var $this = this
          if (area.id) {
            this.areas.push(area)
          } else {

          }
        }

        /**
         * Отмена режима рисования и переход в режим простоя
         */
        MarkPainter.prototype.cancelDrawing = function () {
          for (var i in this.tempLines) {
            this.tempLines[i].el.remove()
          }

          this.toolLine.reDraw()

          this.mode = this.MODE_IDLE
          this.currentPath = []
          this.tempLines = []
        }

        MarkPainter.prototype.getArea = function (markId, remove) {
          for (var i in this.areas) {
            if (this.areas[i] && this.areas[i].id === markId) {
              var area = this.areas[i]
              remove && delete this.areas[i]

              return area
            }
          }

          return null
        }

        MarkPainter.prototype.shiftCoordinatesTransform = function (
          coordinates
        ) {
          var x1 = this.currentPath[this.currentPath.length - 1].x,
            x2 = coordinates.x,
            y1 = this.currentPath[this.currentPath.length - 1].y,
            y2 = coordinates.y,
            angle = 0

          //// При зажатом шифте рисуем прямые линии
          if (this.isShift) {
            angle = Math.atan((y2 - y1) / (x2 - x1)) * (180 / Math.PI)
            if (angle >= 0 && angle <= 90) {
              if (angle > 45) {
                coordinates.x = x1
              } else {
                coordinates.y = y1
              }
            } else {
              if (angle < -45) {
                coordinates.x = x1
              } else {
                coordinates.y = y1
              }
            }
          }

          return coordinates
        }

        /**
         * end mark js
         */

        /**
         * Created by user on 13.05.15.
         */
        /* Point Class */

        /**
         * Класс узла
         *
         * @param coordinates - координаты мыши относительно канвы
         * @constructor
         */
        var MarkPoint = function (coordinates, isFirst) {
          this.RADIUS = 6
          this.COLOR = isFirst ? "#0B0" : "#45D4FF"
          this.DEFAULT = "#FFF"
          this.ACTIVE = "#9CF"
          this.STROKE = 2

          this.x = coordinates.x
          this.y = coordinates.y

          this.el = this.draw()

          this.el.markType = markPainter.TYPE_POINT
        }

        /**
         * Отрисовка узла
         *
         * @returns Raphael Object
         */
        MarkPoint.prototype.draw = function () {
          var $this = this

          return markPainter.paper
            .circle(this.x, this.y, this.RADIUS)
            .attr({
              fill: this.COLOR,
              "stroke-width": this.STROKE,
            })
            .hover(
              function () {
                this.attr("fill", $this.ACTIVE)
              },
              function () {
                this.attr("fill", $this.COLOR)
              }
            )
            .toFront()
        }

        /**
         * Установка цвета узла по умолчанию
         */
        MarkPoint.prototype.setDefault = function () {
          this.COLOR = this.DEFAULT

          this.el.attr("fill", this.COLOR)
        }

        /**
         * end point js
         */

        /* Line Class */

        /**
         * Класс линии
         *
         * @param start - координаты начала линии относительно канвы
         * @param end - координаты конца линии относительно канвы
         * @constructor
         */
        var MarkLine = function (start, end) {
          this.STROKE = 2

          this.setCoordinates(start, end)

          this.el = this.draw()

          this.el.markType = markPainter.TYPE_LINE
        }

        /**
         * Сохранение координат линии
         *
         * @param start - координаты начала линии относительно канвы
         * @param end - координаты конца линии относительно канвы
         */
        MarkLine.prototype.setCoordinates = function (start, end) {
          this.x1 = start ? start.x || 0 : 0
          this.y1 = start ? start.y || 0 : 0
          this.x2 = end ? end.x || 0 : 0
          this.y2 = end ? end.y || 0 : 0
        }

        /**
         * Отрисовка линии
         *
         * @returns Raphael Object
         */
        MarkLine.prototype.draw = function () {
          return markPainter.paper
            .path(this.getPath())
            .attr({
              "stroke-width": this.STROKE,
            })
            .toBack()
        }

        /**
         * Перерисовка линии
         *
         * @param start - координаты начала линии относительно канвы
         * @param end - координаты конца линии относительно канвы
         * @returns Raphael Object
         */
        MarkLine.prototype.reDraw = function (start, end) {
          this.setCoordinates(start, end)

          return this.el.attr("path", this.getPath())
        }

        /**
         * Формирование описания пути из координат линии
         *
         * @returns {string}
         */
        MarkLine.prototype.getPath = function () {
          return "M" + this.x1 + " " + this.y1 + "L" + this.x2 + " " + this.y2
        }
        /**
         * Created by user on 13.05.15.
         */

        /**
         * end Label js
         */

        $(function () {
          var presetsContainer = $("#presets")
          var painterContextMenuLayer = $("#painter-context-menu-layer")
          var layoutCanvas = $("#layout-canvas")
          var layoutImage = layoutCanvas.find("img")

          // console.log('img', layoutImage.width(), layoutImage.height())

          $(document).ready(function () {
            setTimeout(function () {
              layoutCanvas.css({
                // width: '100vw',
                // height: '100%',
                // background: "url(" + img + ")",
                // backgroundPosition: 'center',
                // backgroundRepeat: 'no-repeat',
                // backgroundSize: 'contain'
              })

              $("#layout-canvas svg").remove()
              $(".loading_div").remove()
              // layoutImage.remove();
              const drawSvg = new MarkPainter(layoutCanvas)

              for (let i = 0; i < drawSvg.areas.length; i++) {
                if (drawSvg.areas.length) drawSvg.areas[i].el[0].id = drawSvg.areas[i].id
                // Устанавливаем markId как id для каждого path в svg
              }

              $("#layout-canvas svg").attr('viewBox', `2 3 1925 1015`)
              $("#layout-canvas svg").attr('width', '100%')
              $("#layout-canvas svg").attr('height', '100%')
            }, 500)
          })

          presetsContainer.on("click", "a.toggle-preset-link", function (e) {
            e.preventDefault()

            $($(this).attr("href")).toggle()

            $(this).toggleClass("uarr darr")
          })

          $("body").mouseup(function (e) {
            if (
              !$(e.target).closest(layoutCanvas).length &&
              !$(e.target).closest(painterContextMenuLayer).length &&
              painterContextMenuLayer.is(":visible")
            ) {
              markPainter.executeContextMenuHide()
            }
          })
        })
      })
    }
  }
}
</script>

<style>
#layout-canvas {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.house-titles text {
  pointer-events: none;
  fill: #fff;
}

.house-titles #imageUrl {
  filter: brightness(0.7);
}

#layout-canvas #imageUrl {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  z-index: 0;
}

#layout-canvas svg {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.v-badge {
  position: absolute;
  text-decoration: none;
  padding: 8px 16px;
  color: white;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background: linear-gradient(to bottom, #725fbf, #5340a1);
  border-radius: 999px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  user-select: none;
  max-width: 200px;
  z-index: 9000;
  top: 30px;
  right: 0;
}

.v-badge span {
  width: 25px;
  height: 25px;
  position: absolute;
  top: -12px;
  right: -2px;
  transform: rotate(-20deg);
  filter: blur(0.5px);
}

.v-badge span:before,
.v-badge span:after {
  content: "";
  position: absolute;
}

.v-badge span:before {
  width: 1px;
  height: 100%;
  left: 12px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.7), transparent);
}

.v-badge span:after {
  width: 100%;
  height: 1px;
  top: 12px;
  background: linear-gradient(to left, transparent, rgba(255, 255, 255, 0.7), transparent);
}

.v-badge:before {
  content: "";
  position: absolute;
  z-index: -1;
  background: linear-gradient(30deg, #7f6dc5 60%, white);
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  border-radius: 999px;
}

.inspired {
  position: absolute;
  bottom: 8%;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.inspired:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* #layout-canvas #imageUrl {
  border: 3px solid #e91c31;
} */

circle {
  display: none;
}

.vw_100 {
  overflow: auto;
}

.on_hover #layout-canvas svg path {
  fill: rgb(234 28 49 / 0%) !important;
  stroke: rgb(0 0 0 / 0%) !important;
}

.on_hover #layout-canvas svg path:hover {
  fill: #ca9760d6 !important;
  cursor: pointer;
}

.on_hover #layout-canvas svg tspan {
  font-size: 18px;
}

.plan__size::-webkit-scrollbar {
  width: 10px;
  /* width of the entire scrollbar */
}

.plan__size::-webkit-scrollbar-track {
  background: #f1f5f8;
  /* color of the tracking area */
}

.plan__size::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  /* color of the scroll thumb */
  border-radius: 10px;
  /* roundness of the scroll thumb */
  border: 3px solid #f1f5f8;
  /* creates padding around scroll thumb */
}

.click_slider {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  padding: 0 85px;
  pointer-events: none;
}

.click_slider div {
  border-radius: 50%;
  background: #fff;
  background: rgba(255, 255, 255, 0.7);
  -webkit-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.15);
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.15);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: all;
}

.click_slider div i {
  font-size: 26px;
  color: #ca9760 !important;
}

.none_hiddin .el-drawer {
  overflow: initial;
}</style>
